import React, { useState, useEffect, useRef } from "react";
import { useInterval } from "../hook/CustomHook";

export default function Counter({
  defalutCount = 0,
  isCooldown = false,
  toZero,
  isRun = true,
  milliseconds = 1000,
}) {
  const [count, setCount] = useState(defalutCount);
  const [delay, setDelay] = useState(milliseconds);
  const [isRunning, setIsRunning] = useState(isRun);

  useEffect(() => {
    if (count === 0) toZero();
  }, [count]);

  useInterval(
    () => {
      isCooldown ? setCount(count - 1) : setCount(count + 1);
    },
    isRunning ? delay : null
  );

  return count;
}
